__turbopack_context__.v({
  "dotFlashing": "index-module-scss-module___xJlDq__dotFlashing",
  "dots": "index-module-scss-module___xJlDq__dots",
  "inline": "index-module-scss-module___xJlDq__inline",
  "loading": "index-module-scss-module___xJlDq__loading",
});
